import { ChatWithShortInfo } from "@sms/shared/chat/chat.interface";
import { Task } from "redux-saga";
import { call, cancel, Effect, fork, put, take } from "redux-saga/effects";
import { Socket } from "socket.io-client";

import entryActionsChat from "../chat.entry-actions";
import { socketChats } from "../chat.sockets";

import archiveActions from "./archive.actions";

interface ActionSaga {
  type: string;
  payload: boolean;
}

let fetchChatsArchivedTask: Task | null = null;

const fetchListAcrhiveChats: () => Promise<ChatWithShortInfo[]> = async () => {
  return (await socketChats.emitWithAck("fetchArchivedChats")) as ChatWithShortInfo[];
};

function* fetchChatsArchived(): Generator<Effect | Generator, void> {
  try {
    const chats: ChatWithShortInfo[] = (yield call(fetchListAcrhiveChats)) as ChatWithShortInfo[];

    yield put(archiveActions.handleFetchArchiveChats(chats));
  } catch (e) {
    if (e instanceof Error) {
      console.error("socket error:", e);
    }
    yield put(archiveActions.handleFetchArchiveChatsFailed());
  }
}

function* fetchChatsArchivedSaga(): Generator<Effect | Generator, void, ActionSaga | Task> {
  while (true) {
    const action: ActionSaga = (yield take(archiveActions.handleSwitchToArchiveFolder)) as ActionSaga;
    if (action.payload == true) {
      fetchChatsArchivedTask = (yield fork(fetchChatsArchived)) as Task;
    } else {
      if (fetchChatsArchivedTask != null) {
        yield cancel(fetchChatsArchivedTask);
      }
    }
  }
}

export function* archiveSaga(): Generator<Effect | Generator, void, Socket<any>> {
  while (true) {
    yield take(entryActionsChat.handleConnectSocketChat);

    yield fork(fetchChatsArchivedSaga);
  }
}
